import { getAncestorNodes } from '@/pages/Logiblocks/graphTraversal';
import type { ReactFlowEdge, ReactFlowNode } from '@/pages/Logiblocks/types';

export const isDelayUntilEvent = (node: ReactFlowNode): boolean =>
  node.data.delay_action?.until_event !== undefined;

/**
 * The Delay until event nodes a step can go back to: the ones above it in the same part of the
 * workflow, nearest first. A run can only go back within a loop's body, or within the main
 * workflow, never across the two, so a Delay on the other side of a loop's edge does not count.
 *
 * `includingNode` also counts `nodeId` itself, for a step that is not added yet: its parent may
 * be the Delay.
 */
export function getDelaysAbove(
  nodeId: string,
  nodes: ReactFlowNode[],
  edges: ReactFlowEdge[],
  { includingNode = false }: { includingNode?: boolean } = {}
): ReactFlowNode[] {
  const start = nodes.find((n) => n.id === nodeId);
  if (!start) return [];
  const above = [
    ...(includingNode ? [start] : []),
    ...getAncestorNodes(nodeId, nodes, edges),
  ];
  return above.filter(
    (node) => isDelayUntilEvent(node) && node.parentId === start.parentId
  );
}

/** How a Delay reads in the "Return to" list: its place in the workflow and its name. */
export const delayLabel = (delay: ReactFlowNode, nodes: ReactFlowNode[]) =>
  `${nodes.findIndex((n) => n.id === delay.id) + 1}. ${
    delay.data.custom_display_name || 'Delay until event'
  }`;
